/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {SuccessCover, SuccessLayout, SuccessQuote, SuccessRate, SuccessSupport, BlogSocials, Meta} from "@/comps/index";
import {assetUrl} from "@/utils/cdn";
import {getServerSideProps as SSG} from "@/ssr/common";
export const getServerSideProps = SSG;
const MDXLayout = SuccessLayout;
function _createMdxContent(props) {
  return _jsxs(_Fragment, {
    children: [_jsx(Meta, {
      title: "Creator success story - @lerosia",
      description: "Learn from inspiring success stories of Zoomerang creators on creating and selling video templates on Template Marketplace. See how video creators achieved real results with monetization.",
      tags: "#successfulstory, #videocreator, #videotemplate",
      cover: assetUrl("/covers/success-story.jpg")
    }), "\n", _jsx(SuccessCover, {
      username: "lerosia",
      nickname: "Lerosia",
      short: "Lerosia",
      source: "lerosia",
      title: "Monetize your passions, talents, and skills!",
      paragraphs: ["During my final year at university, the pandemic began, and I suddenly found myself with a lot of free time. It was during this period that I came across some extraordinary videos with fascinating effects and realized that I was also interested in learning how to create similar videos. Starting with learning how to edit on my phone, eventually moved on to mastering After Effects software.", "Through my online endeavors, I had the opportunity to connect with like-minded individuals who were also interested in video creation. Together, we began to produce creative videos for bloggers, which gradually evolved into a lucrative business."]
    }), "\n", _jsx(SuccessRate, {
      engagement: "25%",
      followers: "45K",
      revenue: "$1,000+",
      title: "Increase Income & Build Network",
      advice: "As a creator, l use Zoomerang to increase my income stream while doing what I love. I get my work featured in front of millions of people and join a community of creators, carefully selected by the Zoomerang team of experts."
    }), "\n", _jsx(SuccessSupport, {
      engagement: "25%",
      followers: "45K",
      revenue: "$1,000+",
      support: "The Zoomerang team has been providing me with outstanding support. They are incredibly helpful in answering all my inquiries, assisting me with creating content, and successfully resolving any technical issues I encountered. Their exceptional service made my experience with Zoomerang all the more enjoyable and stress-free.",
      success: "As a Zoomerang Marketplace creator, I have noticed a substantial uptick in my engagement rates across various social media platforms. Additionally, I have been able to attract numerous followers and earned income through various means, such as:"
    }), "\n", _jsx(SuccessQuote, {
      name: "Lerosia",
      role: "Template Creator at Zoomerang",
      quote: "This is a great platform to grow your income and expand your reach. With increased exposure, tools and resources, and convenient payment systems there's no better way to take your video creation business to the next level!",
      source: "lerosia"
    }), "\n", _jsx(BlogSocials, {})]
  });
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
